import { Container } from "@/components/ui/container";
import { SectionHeading } from "@/components/ui/section-heading";
import { problemPoints } from "@/lib/content";

export function Problem() {
  return (
    <section aria-labelledby="problem-heading" className="bg-secondary/30 py-16 sm:py-24">
      <Container>
        <SectionHeading
          titleId="problem-heading"
          eyebrow="Privacy work gets fragmented fast"
          title="The hard part is turning requirements into an operating routine."
          description="Small businesses rarely need more legal text. They need a clear way to decide what may apply, do the work, keep evidence, and know what needs attention next."
        />

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {problemPoints.map((point) => (
            <li
              key={point.title}
              className="min-w-0 rounded-xl border border-border bg-card p-6 shadow-card"
            >
              <h3 className="text-base font-semibold text-foreground">{point.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{point.body}</p>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
